import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import QRCodeVue3Async from "./QRCodeVue3Async.vue";

export interface Props {
  value: string;
  width?: number;
  height?: number;
  margin?: number;
  imgclass?: string;
  myclass?: string;
  downloadButton?: string;
  buttonName?: string;
  qrOptions?: any;
  imageOptions?: any;
  dotsOptions?: any;
  backgroundOptions?: any;
  cornersSquareOptions?: any;
  cornersDotOptions?: any;
  fileExt?: string;
  image?: string;
  download?: boolean;
  downloadOptions?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'QRCodeVue3',
  props: {
    value: { default: "" },
    width: { default: 300 },
    height: { default: 300 },
    margin: { default: 0 },
    imgclass: { default: "" },
    myclass: { default: "" },
    downloadButton: { default: "" },
    buttonName: { default: "Download" },
    qrOptions: { default: {
    typeNumber: 0,
    mode: "Byte",
    errorCorrectionLevel: "Q"
  } },
    imageOptions: { default: { hideBackgroundDots: true, imageSize: 0.4, margin: 0 } },
    dotsOptions: { default: {
    type: "dots",
    color: "#6a1a4c",
    gradient: {
      type: "linear",
      rotation: 0,
      colorStops: [
        { offset: 0, color: "#6a1a4c" },
        { offset: 1, color: "#6a1a4c" }
      ]
    }
  } },
    backgroundOptions: { default: { color: "#ffffff" } },
    cornersSquareOptions: { default: { type: "dot", color: "#000000" } },
    cornersDotOptions: { default: { type: undefined, color: "#000000" } },
    fileExt: { default: "png" },
    image: { default: "" },
    download: { type: Boolean, default: false },
    downloadOptions: { default: { name: "vqr", extension: "png" } }
  },
  setup(__props: any) {

//import { computed, reactive, ref, watch } from "vue";
const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Suspense, null, {
    default: _withCtx(() => [
      _createVNode(QRCodeVue3Async, {
        "background-options": props.backgroundOptions,
        "button-name": props.buttonName,
        "corners-dot-options": props.cornersDotOptions,
        "corners-square-options": props.cornersSquareOptions,
        "dots-options": props.dotsOptions,
        download: props.download,
        "download-button": props.downloadButton,
        "download-options": props.downloadOptions,
        "file-ext": props.fileExt,
        height: props.height,
        image: props.image,
        "image-options": props.imageOptions,
        imgclass: props.imgclass,
        margin: props.margin,
        value: props.value,
        myclass: props.myclass,
        "qr-options": props.qrOptions,
        width: props.width
      }, null, 8, ["background-options", "button-name", "corners-dot-options", "corners-square-options", "dots-options", "download", "download-button", "download-options", "file-ext", "height", "image", "image-options", "imgclass", "margin", "value", "myclass", "qr-options", "width"])
    ]),
    _: 1
  }))
}
}

})